module.exports = __webpack_public_path__ + "img/full-logo-purple.f180a78f.png";